import React from "react";

export default function DeterminantsQuiz() {
  return <h1 className="text-4xl text-white"> Come Back Later! </h1>;
}
